import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Legend from 'components/common/Legend/Legend'
import Button from 'components/common/Button/Button'
import * as UI from '../Shared.styles'

const CommunicationPreferencesView = ({
  reminders,
  promotions,
  onEdit
}) =>
  <Fragment>
    <Legend label="Reminders">{ reminders }</Legend>
    <Legend label="Promotions">{ promotions }</Legend>
    <UI.Buttons>
      <Button data-at-communication-preferences-edit-button onClick={ onEdit }>Edit</Button>
    </UI.Buttons>
  </Fragment>

export default CommunicationPreferencesView

CommunicationPreferencesView.propTypes = {
  onEdit: PropTypes.func,
  promotions: PropTypes.string,
  reminders: PropTypes.string
}
